export default __webpack_public_path__ + "static/media/dimmedCheck.2c069b72.svg";